import {GroupCelebration, GroupCelebrationStatus} from "@irati/types"

const getGreetingCardUsersPreviews = (groupCelebration: GroupCelebration) => {
  if (groupCelebration.status === GroupCelebrationStatus.Scheduled || !groupCelebration.messages?.length) {
    return [groupCelebration.author, ...groupCelebration.collaborators!]
  }
  const authorMessageIndex = groupCelebration.messages.findIndex((msg) => {
    return msg.createdBy?.uuid === groupCelebration.author.uuid
  })
  const usersHasLeftAMessage = groupCelebration.messages.map((msg) => {
    return msg.createdBy
  })
  if (authorMessageIndex >= 0) {
    usersHasLeftAMessage.splice(authorMessageIndex, 1)
    return [groupCelebration.author, ...usersHasLeftAMessage]
  }
  return usersHasLeftAMessage
}

export default getGreetingCardUsersPreviews
